import "./UnitRoomFilter.scss"
import React, {useEffect, useRef, useState} from "react";
import {updateQueryString} from "../../util/url";

export function UnitRoomFilter(p: {
  rooms1: number | boolean,
  rooms2: number | boolean,
  rooms3: number | boolean,
  rooms4p: number | boolean,
  active1: boolean,
  active2: boolean,
  active3: boolean,
  active4p: boolean,
  houses: number
}) {

  const isMounted = useRef(false)

  const [a1, setA1] = useState(p.active1)
  const [a2, setA2] = useState(p.active2)
  const [a3, setA3] = useState(p.active3)
  const [a4, setA4] = useState(p.active4p)

  const c1 = (p.rooms1 !== false ? "" : "disabled") + " " + (a1 ? "active" : "");
  const c2 = (p.rooms2 !== false ? "" : "disabled") + " " + (a2 ? "active" : "");
  const c3 = (p.rooms3 !== false ? "" : "disabled") + " " + (a3 ? "active" : "");
  const c4 = (p.rooms4p !== false ? "" : "disabled") + " " + (a4 ? "active" : "");

  const updUrl = () => {
    const apts = []
    if (a1) apts.push(1)
    if (a2) apts.push(2)
    if (a3) apts.push(3)
    if (a4) apts.push(4)
    updateQueryString({apts})
  }

  useEffect(() => {
    if(isMounted.current) {
      updUrl()
    }
  }, [a1, a2, a3, a4]);

  useEffect(() => {
    isMounted.current = true
  }, [])

  return <>
    <div className="aptbuttons">
      <button className={c1} onClick={() => {
        setA1(!a1);
      }}>1
      </button>
      <button className={c2} onClick={() => {
        setA2(!a2);
      }}>2
      </button>
      <button className={c3} onClick={() => {
        setA3(!a3);
      }}>3
      </button>
      <button className={c4} onClick={() => {
        if (p.rooms4p) {
          setA4(!a4)
        }
      }}>4+
      </button>
    </div>
    <div className="filters">
      {/*{p.houses>1?<HousePopupButton/>:null}*/}
      {/*<FilterTrigger/>*/}
    </div>
  </>
}